import { useContext } from "react";
import { I18nContext } from "./I18nProvider";
import type { TranslationFunction } from "./translations";

export function useTranslations(): TranslationFunction {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useTranslations must be used within I18nProvider");
  return ctx.t;
}
